export default {

  state: {
    editedSchedule: null
  },

  mutations: {

    clearEditedJingleSchedule (state) {
      state.editedSchedule = null
    },

    initEditedJingleSchedule (state) {
      state.editedSchedule = {
        selectedDaysOfWeek: new Set(),
        day: 0,
        fromHours: '07',
        fromMinutes: '00',
        toHours: '23',
        toMinutes: '00',
        interval: 60,
        activeFrom: null,
        activeTo: null,
        selectedJingles: []
      }
    },

    updateEditedJingleSchedule (state, update) {
      const newSchedule = Object.assign({}, state.editedSchedule)
      newSchedule[update.key] = update.value
      state.editedSchedule = newSchedule
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jingleScheduleEdit.js